// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-08af4b06] .v--modal .header {
  padding: 15px 20px 20px 15px;
}
[data-v-08af4b06] .v--modal .footer {
  padding: 0px 12px 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
[data-v-08af4b06] .v--modal .footer .btn {
  width: 120px;
}
.modal-body[data-v-08af4b06] {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}
.modal-body .item[data-v-08af4b06] {
  display: flex;
  align-items: baseline;
}
.modal-body .item span[data-v-08af4b06] {
  width: 115px;
}
.modal-body .item.input-item[data-v-08af4b06] {
  height: 40px;
  display: flex;
  align-items: center;
}
.modal-body .item input[data-v-08af4b06] {
  color: var(--font-color);
  background-color: var(--bg-color);
  border-top: none;
  border-bottom: 1px solid var(--list-item-bordercolor2);
  border-inline: unset;
  transition: all 0.2s;
}
.modal-body .item input[data-v-08af4b06]:focus {
  border-bottom: 1px solid var(--ref-link-color);
  outline: none;
}
.modal-body .notification[data-v-08af4b06] {
  height: 32px;
  display: flex;
}
.modal-body .notification span[data-v-08af4b06] {
  width: 230px;
  text-align: center;
}
.modal-body .redColor[data-v-08af4b06] {
  color: var(--elem-red-color);
}
.modal-body .greenColor[data-v-08af4b06] {
  color: var(--elem-green-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/integrations/MSExchangeSettings.vue"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,sDAAsD;EACtD,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,8CAA8C;EAC9C,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC","sourcesContent":["[data-v-08af4b06] .v--modal .header {\n  padding: 15px 20px 20px 15px;\n}\n[data-v-08af4b06] .v--modal .footer {\n  padding: 0px 12px 12px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n[data-v-08af4b06] .v--modal .footer .btn {\n  width: 120px;\n}\n.modal-body[data-v-08af4b06] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 auto;\n}\n.modal-body .item[data-v-08af4b06] {\n  display: flex;\n  align-items: baseline;\n}\n.modal-body .item span[data-v-08af4b06] {\n  width: 115px;\n}\n.modal-body .item.input-item[data-v-08af4b06] {\n  height: 40px;\n  display: flex;\n  align-items: center;\n}\n.modal-body .item input[data-v-08af4b06] {\n  color: var(--font-color);\n  background-color: var(--bg-color);\n  border-top: none;\n  border-bottom: 1px solid var(--list-item-bordercolor2);\n  border-inline: unset;\n  transition: all 0.2s;\n}\n.modal-body .item input[data-v-08af4b06]:focus {\n  border-bottom: 1px solid var(--ref-link-color);\n  outline: none;\n}\n.modal-body .notification[data-v-08af4b06] {\n  height: 32px;\n  display: flex;\n}\n.modal-body .notification span[data-v-08af4b06] {\n  width: 230px;\n  text-align: center;\n}\n.modal-body .redColor[data-v-08af4b06] {\n  color: var(--elem-red-color);\n}\n.modal-body .greenColor[data-v-08af4b06] {\n  color: var(--elem-green-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
